export const LAYOUT1 = 'layout1';
export const LAYOUT2 = 'layout2';
export const LAYOUT3 = 'layout3';
